// #region IMPORTS 
import { createSlice } from "@reduxjs/toolkit";
// #endregion

// #region CONSTANTS 
const initialState = {
  isLoading: false
};
// #endregion

export const StudyViewSlice = createSlice({
  initialState,
  name: "studyView",
  reducers: {
    setIsLoading(state, action){
      state.isLoading = action.payload
    }
  }
});

// #region ACTIONS
export const { setIsLoading } = StudyViewSlice.actions;
// #endregion

// #region SELECTORS 
// #endregion

export default StudyViewSlice.reducer;
